import { FC } from 'react';
import { Loader as LoaderPKG } from '@zeeve-platform/loader-component';

// Default spinner source image
import SpinnerIcon from '../assets/spinner.svg';

/** type declaration for Loader props */
export type LoaderProps = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

/**
 * Loader component
 * @returns JSX.Element
 */
const Loader: FC<LoaderProps> = ({ src, ...props }): JSX.Element => {
    return (
        <div>
            <LoaderPKG imagePath={src as string} {...props} />
        </div>
    );
};

Loader.defaultProps = {
    src: SpinnerIcon,
};

export default Loader;
